"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
require("core-js/modules/es.json.stringify.js");
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _vm.isComingSoon ? _c("div", {
    staticClass: "coming-soon-container"
  }, [_vm._m(0)]) : _c("div", [_c("div", {
    staticClass: "dashboard-executive-container"
  }, [_c("el-row", {
    staticClass: "panel-group",
    attrs: {
      gutter: 10
    }
  }, [_c("el-col", {
    staticStyle: {
      margin: "2px 0"
    },
    attrs: {
      xs: 18,
      sm: 12,
      lg: 8
    }
  }, [_c("VueCtkDateTimePicker", {
    staticClass: "filter-item",
    attrs: {
      range: "",
      right: true,
      color: _vm.$primaryColor,
      formatted: "DD-MM-YYYY",
      "input-size": "sm",
      shortcut: "thisMonth",
      "custom-shortcuts": _vm.customShortcuts
    },
    model: {
      value: _vm.dateRange,
      callback: function ($$v) {
        _vm.dateRange = $$v;
      },
      expression: "dateRange"
    }
  })], 1), _c("el-col", {
    staticStyle: {
      margin: "2px 0"
    },
    attrs: {
      xs: 24,
      sm: 12,
      lg: 8
    }
  }, [_vm.isDatePanelVisible ? _c("div", {
    staticStyle: {
      display: "flex"
    }
  }, [_c("el-select", {
    attrs: {
      placeholder: "Select Person",
      clearable: ""
    },
    model: {
      value: _vm.selectedAdminId,
      callback: function ($$v) {
        _vm.selectedAdminId = $$v;
      },
      expression: "selectedAdminId"
    }
  }, _vm._l(_vm.adminsList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.fullName,
        value: item.id
      }
    });
  }), 1)], 1) : _vm._e()]), _c("el-col", {
    staticStyle: {
      "margin-top": "2px"
    },
    attrs: {
      xs: {
        span: 24,
        offset: 0
      },
      sm: 12,
      lg: 2,
      offset: 4
    }
  }, [!_vm.isSales ? _c("router-link", {
    attrs: {
      to: "/leads/add"
    }
  }, [_c("el-button", {
    attrs: {
      type: "primary",
      size: "small",
      icon: "el-icon-plus"
    }
  }, [_vm._v(" Add New Lead ")])], 1) : _vm._e()], 1)], 1), _c("el-row", {
    attrs: {
      gutter: 10
    }
  }, [_c("el-col", [_c("panel-group", {
    attrs: {
      "date-range": _vm.dateRange,
      "selected-admin-id": _vm.selectedAdminId
    }
  })], 1)], 1), _vm.isDatePanelVisible ? _c("el-row", {
    attrs: {
      gutter: 10
    }
  }, [_c("el-col", {
    attrs: {
      xs: 24,
      sm: 12,
      lg: 12
    }
  }, [_c("lead-bar-chart", {
    key: JSON.stringify(_vm.dateRange),
    attrs: {
      "date-range": _vm.dateRange
    }
  })], 1), _c("el-col", {
    attrs: {
      xs: 24,
      sm: 12,
      lg: 12
    }
  }, [_c("el-row", {
    attrs: {
      gutter: 10
    }
  }, [_c("el-col", {
    attrs: {
      xs: 24,
      sm: 12,
      lg: 12
    }
  }, [_c("source-pie-chart", {
    key: JSON.stringify(_vm.dateRange),
    attrs: {
      "date-range": _vm.dateRange
    }
  })], 1), _c("el-col", {
    attrs: {
      xs: 24,
      sm: 12,
      lg: 12
    }
  }, [_c("sample-stats-radial-bar-chart", {
    key: JSON.stringify(_vm.dateRange),
    attrs: {
      "date-range": _vm.dateRange
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _c("el-row", {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      gutter: 10
    }
  }, [_c("el-col", {
    attrs: {
      xs: 24,
      sm: 12,
      lg: 12
    }
  }, [_c("follow-up-and-task-table")], 1), _c("el-col", {
    staticClass: "leads-table",
    attrs: {
      xs: 24,
      sm: 12,
      lg: 12
    }
  }, [!_vm.isDispatcher ? _c("leads-table") : _vm._e()], 1)], 1), false ? _c("el-row", {
    attrs: {
      gutter: 10
    }
  }, [_c("el-col", {
    attrs: {
      xs: 24,
      sm: 12,
      lg: 12
    }
  }, [_vm.isDatePanelVisible ? _c("inquiry-value", {
    key: JSON.stringify(_vm.dateRange),
    attrs: {
      "date-range": _vm.dateRange
    }
  }) : _vm._e()], 1), _c("el-col", {
    attrs: {
      xs: 24,
      sm: 12,
      lg: 6
    }
  }, [_c("leaderboard-table", {
    key: _vm.dateRange,
    attrs: {
      "date-range": _vm.dateRange
    }
  })], 1), _c("el-col", {
    attrs: {
      xs: 24,
      sm: 12,
      lg: 6
    }
  }, [_c("monthly-leaderboard-table", {
    key: _vm.dateRange,
    attrs: {
      "date-range": _vm.dateRange
    }
  })], 1)], 1) : _vm._e()], 1)]);
};
var staticRenderFns = exports.staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "coming-card"
  }, [_c("h1", [_vm._v("Dashboard")]), _c("h2", [_vm._v("Coming Soon 🚀")]), _c("p", [_vm._v("We're currently upgrading this section.")])]);
}];
render._withStripped = true;